import { useMemo, type ComponentType } from 'react'
import { QueryClient, useQueryClient } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider, type LoaderFunctionArgs } from 'react-router-dom'
import AppRoot, { ErrorBoundary } from '../../pages/root'
import { paths } from './path'
import { UserRoles } from '@/shared/utils/types/roles'
import { convertWithRoles } from './roleProtection'

type ModuleWithLoader = {
  clientLoader?: (queryClient: QueryClient) => (params: LoaderFunctionArgs<unknown>) => Promise<unknown>
  default: ComponentType
}

const convert = (queryClient: QueryClient) => (m: ModuleWithLoader) => {
  const { clientLoader, default: Component, ...rest } = m
  return {
    ...rest,
    loader: clientLoader ? clientLoader(queryClient) : undefined,
    Component,
  }
}

const createAppRouter = (queryClient: QueryClient) =>
  createBrowserRouter(
    [
      {
        path: paths.app.root.path,
        Component: AppRoot,
        ErrorBoundary: ErrorBoundary,
        children: [
          {
            index: true, //
            lazy: () => import('@/pages/dashboardPage').then(convert(queryClient)),
          },
          {
            path: paths.app.users.path,
            lazy: () =>
              import('@/pages/userManagementPage').then(
                convertWithRoles(queryClient, {
                  any: [UserRoles.Admin],
                }),
              ),
          },
          // {
          //       path: paths.app.admin.stationEditor.root.path,
          //       lazy: () =>
          //         import('@/pages/admin/stationEditor').then(
          //           convertWithRoles(queryClient, {
          //             any: [UserRoles.Admin, ],
          //           }),
          //         ),
          //     },

          // {
          //   path: paths.app.logs.path,
          //   lazy: () => import('@/pages/logs').then(convert(queryClient)),
          // },
          // {
          //   path: paths.app.businessUnits.path,
          //   lazy: () => import('@/pages/businessUnitsPage').then(convert(queryClient)),
          // },
          // {
          //   path: paths.app.locations.path,
          //   lazy: () => import('@/pages/locationsPage').then(convert(queryClient)),
          // },
          // {
          //   path: paths.app.partTypes.path,
          //   lazy: () => import('@/pages/partTypePage').then(convert(queryClient)),
          // },
        ],
      },
      {
        path: '*',
        lazy: () => import('@/pages/notFoundPage').then(convert(queryClient)),
      },
    ],
    {
      future: {
        v7_relativeSplatPath: true,
      },
    },
  )

const AppRouter = () => {
  const queryClient = useQueryClient()
  const router = useMemo(() => createAppRouter(queryClient), [queryClient])

  return <RouterProvider router={router} />
}

export { AppRouter }
